// D1's CURRENT_TIMESTAMP columns (email_events, audit_logs) come back as
// "YYYY-MM-DD HH:MM:SS" — UTC but with no timezone marker. new Date() would
// parse that bare format as *local* time (and the space form is implementation-
// dependent), so a just-written row could show a time hours off.
// Normalize to UTC unless the value already carries a zone.
export function parseDbTimestampUtc(value: string): Date {
  const hasZone = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value)
  const iso = value.includes("T") ? value : value.replace(" ", "T")
  return new Date(hasZone ? iso : `${iso}Z`)
}
